module.exports = __webpack_public_path__ + "static/media/icon-step.a8f5bfee.svg";